import { searchParamFromUrl } from '../ParamsProvider/searchParams'

export const getLatLngFromWindowUrl = () => {
  const queryLatitude = searchParamFromUrl('lat')
  const queryLongitude = searchParamFromUrl('lng')
  const queryLocationName = searchParamFromUrl('currentLocation')
  return { queryLatitude, queryLocationName, queryLongitude }
}
